const thumb = require('client/image').thumb;
const config = require('config');

const t = require('engine/i18n/t');

module.exports = function(template, locals) {
  locals = locals ? Object.create(locals) : {};
  addStandardHelpers(locals);

  return template(locals);
};

function addStandardHelpers(locals) {
  locals.t = t;
  locals.thumb = thumb;
  locals.lang = config.lang;
  locals.env = config.env;
}

